import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { CacheBuster } from 'ts-cacheable';
import { InsurerList } from 'src/app/insurer/model/insurerList';
import { InsurerEdit } from 'src/app/insurer/model/insurerEdit';

const insurersCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class InsurerService implements OnDestroy
{
  private messagingLanguageChangedSubscription: Subscription;

  constructor(
    private http: HttpClient)
  {
  }

  /**
   * Delete a Insurer.
   *
   * @param id Insurer id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: insurersCacheBuster
    })
  public deleteInsurer(id: number): Observable<InsurerList>
  {
    return this.http.delete<InsurerList>(`/insurer/${id}`);
  }

  /**
   * Save a Insurer.
   *
   * @param data Insurer to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: insurersCacheBuster
    })
  public saveInsurer(data: any, isNew: boolean, insurerId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/insurer', data);
    }
    else
    {
      return this.http.put(`/insurer/${insurerId}`, data);
    }
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get Insurer for grid list.
   */
  public getInsurerList(): Observable<InsurerList[]>
  {
    return this.http.get<InsurerList[]>('/insurers/list');
  }

  /**
   * Get Insurer by id.
   *
   * @param id Insurer id
   */
  public getInsurerById(id: number): Observable<InsurerEdit>
  {
    return this.http.get<InsurerEdit>(`/insurer/${id}`);
  }

  /**
   * Check if Insurer is in use
   *
   * @param id Insurer Id
   */
  public insurerInUse(id: number): Observable<any>
  {
    return this.http.get(`/insurer/inuse/${id}`);
  }

  /**
   * Check if Insurer Name exists to avoid name duplicates
   *
   * @param name Insurer Name
   */
  public existsInsurerName(name: string): Observable<any>
  {
    return this.http.get(`/insurer/exists?name=${name}`);
  }
}
